import React from 'react'
import SegmentsList from '../Segments/SegmentsList'

const ArchivedSegmentsList = props => (
  <SegmentsList {...props} isArchived />
)


export default ArchivedSegmentsList
